import React from "react";
import {Tooltip} from "primereact/tooltip";
import {SUPPORTED_OCR_CHOS} from "@/Config/constants";
import styled from "styled-components";

const TooltipWrap = styled.div`
    i.pi {
        color: var(--blue-500);

        &.large {
            font-size: 20px;
        }
    }
`;

const SupportedOcrChos = () => {
    const supportedChos = SUPPORTED_OCR_CHOS.join('\n- ');

    return <TooltipWrap>
        <i id={'ocr-supported'}
           className={'pi pi-info-circle large'}
        />
        <Tooltip target={'#ocr-supported'}
                 content={
                     "Nightingale currently supports payment packs from the following CHO companies:\n- " + supportedChos + "\n\n" +
                     "The following file types are supported:\n" +
                     "- PDF\n" +
                     "- Word (.docx, .doc)\n" +
                     "- images (.png, .jpeg, .jpg)\n\n" +
                     "It is possible to upload multiple files of different types at the same time, for example, two PDFs and a .jpg file.\n" +
                     "In this case, all these files are merged into one PDF and processed as a single file.\n" +
                     "Both original files and the merged PDF are stored in the system."
                 }
        />
    </TooltipWrap>
}

export default SupportedOcrChos;